import React from "react";
import styled from "styled-components";
import { DEFAULT_TAG_PALETTE, TAG_PALETTES } from "@lifeat/shared/task-management/TaskTagConstants";
import { Tag as TagType } from "@lifeat/shared/task-management/TaskTagTypes";
import { useAppearanceContext } from "@contexts/AppearanceContext";
import { FontSize } from "@themes/Fonts";
import { blendHexColors } from "@util/StyleUtil";

const TagContainer = styled.div<{ backgroundColor: string; hoverColor: string; disableHover: boolean }>`
    display: flex;
    align-items: center;
    width: fit-content;
    max-width: 150px;
    height: fit-content;
    padding: 2px 4px;
    background-color: ${(props) => props.backgroundColor};
    font-size: ${FontSize.small};
    border-radius: 2px;
    gap: 5px;
    cursor: pointer;
    overflow: hidden;

    &:hover {
        background-color: ${(props) => (!props.disableHover ? props.hoverColor : props.backgroundColor)};
    }
`;

const TagTitle = styled.span<{ textColor: string }>`
    color: ${(props) => props.textColor};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

interface TagProps {
    readonly tag: TagType;
    readonly disableHover?: boolean;
    readonly className?: string;
}
export default function TagComponent(props: TagProps) {
    const { lightMode } = useAppearanceContext();
    const palette = TAG_PALETTES.find((c) => c.primary === props.tag.color) ?? DEFAULT_TAG_PALETTE;
    const backgroundColor = lightMode ? palette.lighter : palette.darker;
    const textColor = lightMode ? palette.darker : palette.lighter;
    const hoverColor = blendHexColors(backgroundColor, textColor, 0.8);

    return (
        <TagContainer
            className={props.className}
            backgroundColor={backgroundColor}
            hoverColor={hoverColor}
            disableHover={!!props.disableHover}
        >
            {props.tag.emoji}
            <TagTitle textColor={textColor}>{props.tag.name}</TagTitle>
        </TagContainer>
    );
}
